import { MasterAwardRequest } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const createMasterAward: (
  fetchContext: FetchContext,
  masterAward: MasterAwardRequest,
  accessToken?: string,
) => Promise<number> = async (fetchContext, masterAward, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/admin/master-awards`,
  {
    method: 'POST',
    body: JSON.stringify(masterAward),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<number>(fetchContext.errorStore, response, 'create master award'));
